import React, { useState, useEffect, useRef, createRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment";
import {
  coachDemoImg,
  CalendarIconGray,
  ClockIconGray,
  chatSendIcon,
  ChatIconRed,
  LocationIconGray,
  CancelIconBlack,
  coachDemoImg2,
  ReplyIcon,
} from "../../../../constant/imagePath";
import classes from "./chat.module.css";
import { Input } from "../../../../stories/Input/Input";
import { Button } from "../../../../stories/Button/Button";
import { InputWithSearchIcon } from "../../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { InputWithButton } from "../../../../stories/InputWithButton/InputWithButton";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import StudentDetails from "./StudentDetails";
import $ from "jquery";
import RoomBox from "../../../../stories/RoomBox/RoomBox";

export const MessageBox = ({
  item,
  isImage,
  i,
  showName,
  onClick,
  setReplyObject,
}) => {
  return (
    <div
      className={[classes.dflex, classes.itemsend, classes.relative].join(" ")}
      key={i}
    >
      {!isImage ? (
        <div className={[classes.chattingImgDiv].join(" ")} />
      ) : (
        <>
          <div className={[classes.chattingImgDiv]} onClick={onClick}>
            <img
              src={item?.user_id.img}
              className={[classes.chattingImg].join(" ")}
              alt="..."
            />
          </div>
          <div
            style={{
              backgroundColor: item?.user_id.isOnline
                ? Colors.additionalShadesOfKellyGreen1
                : Colors.neutralShadesOfPinkSwan,
            }}
            className={[classes.greenOnlineIcon].join(" ")}
          />
        </>
      )}

      {item?.reply ? (
        <div
          className={[classes.ml12, classes.personChatBox].join(" ")}
          style={{
            backgroundColor: Colors.neutralShadesOfWhiteSmoke,
          }}
        >
          <h6
            className={[classes.mb8].join(" ")}
            style={{
              ...Fonts.h7,
              color: Colors.neutralShadesOfNero,
              fontFamily: "inter-600",
              lineHeight: "24px",
            }}
          >
            {item?.user_id.name}
          </h6>
          <div
            style={{ borderLeft: `2px solid ${Colors.mainBlue}` }}
            className={[classes.MessageBoxRepliedDiv]}
          >
            <p
              className={[classes.mb8].join(" ")}
              style={{
                ...Fonts.h7,
                color: Colors.neutralShadesOfNero,
                fontFamily: "inter-600",
                lineHeight: "24px",
              }}
            >
              {item?.reply?.user_id.name}
            </p>
            <p
              style={{
                ...Fonts.p1,
                color: Colors.neutralShadesOfNero,
              }}
              className={[classes.MessageBoxRepliedText]}
            >
              {item?.reply?.messageText}
            </p>
          </div>
          <p
            style={{
              ...Fonts.p1,
              color: Colors.neutralShadesOfNero,
            }}
          >
            {item?.messageText}
          </p>
        </div>
      ) : (
        <div
          className={[classes.ml12, classes.personChatBox].join(" ")}
          style={{
            backgroundColor: Colors.neutralShadesOfWhiteSmoke,
          }}
        >
          {showName && (
            <p
              className={[classes.mb8].join(" ")}
              style={{
                ...Fonts.h7,
                color: Colors.neutralShadesOfNero,
                fontFamily: "inter-600",
                lineHeight: "24px",
              }}
            >
              {item?.user_id.name}
            </p>
          )}

          <p
            style={{
              ...Fonts.p1,
              color: Colors.neutralShadesOfNero,
            }}
          >
            {item?.messageText}
          </p>
        </div>
      )}
      <div className={[classes.replyIcon]}>
        <ReactSVG src={ReplyIcon} onClick={() => setReplyObject(item)} />
      </div>
    </div>
  );
};

const ChatScreen = () => {
  const emptyScrollRef = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [replyObject, setReplyObject] = useState(null);

  const [searchuser, setSearchuser] = useState();
  const [sendmessage, setSendMessage] = useState("");
  const [selectedroom, setSelectedroom] = useState();
  const [selectedRoomAllMessages, setSelectedRoomAllMessages] = useState([]);

  const users = [
    {
      id: 1,
      img: coachDemoImg,
      name: "Kate Middleton",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: false,
        location: "Green Tennis Court",
      },
      event: {
        status: "Lessson request",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Kate and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
    {
      id: 2,
      img: coachDemoImg,
      name: "Jeanie Weesley",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: true,
        location: "Green Tennis Court",
      },
      event: {
        status: "Upcoming lesson in 3 days",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Jeanie and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
    {
      id: 3,
      img: coachDemoImg,
      name: "Weesley",
      lastMessage: {
        time: moment().format("h:mm A"),
        date: moment().format("MMM DD, YYYY"),
        message: "Hi, John",
        isSeen: false,
        location: "Green Tennis Court",
      },
      event: {
        status: "Lesson completed",
      },
      age: 27,
      rating: 4,
      aboutMe:
        "Hello, my name is Weesley and I am 28 years old. I just moved to the U.S from Macedonia. I have played competitive tennis 10+ years . I am well aware of all the different types of players there are. I am passionate about the sport.",
      experience: [
        { title: "tennis", label: "Beginner" },
        { title: "box", label: "Beginner" },
      ],
      myCoaches: [
        {
          id: 5,
          name: "Mackenzie McDonald",
          location: "Washington, DC",
          sport: "Tennis",
          rating: 5,
          img: coachDemoImg2,
        },
      ],
    },
  ];
  const messages = [
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand same",
      creadtedAt: "May 25 2022 3:13:05",
      user_id: {
        name: "Kate ",
        isOnline: false,
        img: coachDemoImg,
        id: 123,
      },
      reply: null,
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand same 2",
      creadtedAt: "May 25 2022 3:13:05",
      user_id: {
        name: "Kate ",
        isOnline: false,
        img: coachDemoImg,
        id: 123,
      },
      reply: null,
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my backhand",
      creadtedAt: "May 24 2022 3:13:05",
      user_id: {
        name: "Kate Middle",
        isOnline: false,
        img: coachDemoImg,
        id: 1234,
      },
      reply: null,
    },
    {
      id: Math.random() * 1000,
      messageText: "Hi John, I’m interested in practicing my fronthand",
      booking: "confirmed",
      creadtedAt: "May 23 2022 3:13:05",
      user_id: {
        name: "Kate Middleton",
        isOnline: true,
        img: coachDemoImg,
        id: 12345,
      },
      reply: null,
    },
  ];

  const roomChat = (item, i) => {
    setSelectedroom(item);
    setSelectedRoomAllMessages(messages);
  };
  const scrollToBottom = () => {
    emptyScrollRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const CheckHeightAndUpdateMargin = () => {
    $(function () {
      var messageContainerHeight = $(`.${classes.chattingBoxRow}`).height();
      var messageColHeight = $(`.${classes.messageCol}`).height();
      if (messageContainerHeight < messageColHeight) {
        $(`.${classes.scrollToBottomContainer}`).css("margin-bottom", "0px");
      }
      // chattingbox
      scrollToBottom();
    });
  };

  const HandleSendMessage = () => {
    const newArray = [
      ...selectedRoomAllMessages,
      {
        id: Math.random() * 1000,
        messageText: sendmessage,
        creadtedAt: moment().format("MMM DD YYYY h:mm:ss"),
        user_id: {
          name: "Kate ",
          isOnline: false,
          img: coachDemoImg,
          id: 123,
        },
        reply: replyObject,
      },
    ];
    setSelectedRoomAllMessages(newArray);
    setSendMessage("");
    setReplyObject(null);
    CheckHeightAndUpdateMargin();
    // scroll.scrollToBottom();
  };

  return (
    <Container fluid className={[classes.container].join(" ")}>
      <Row className={["g-0", classes.row].join(" ")}>
        <Col md={4} className={[classes.mainSideChatDiv].join(" ")}>
          <div className={[classes.search].join(" ")}>
            <InputWithSearchIcon
              type="text"
              placeholder="Search"
              state={searchuser}
              setter={setSearchuser}
            />
          </div>
          <div className={[classes.userChatMainDiv].join(" ")}>
            {users?.length > 0 ? (
              users?.map((item, i) => {
                return (
                  <div
                    style={{
                      borderBottom:
                        i !== users.length - 1 &&
                        `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                  >
                    <RoomBox
                      item={item}
                      i={i}
                      onClick={(e) => roomChat(e, i)}
                      selectedroom={selectedroom}
                    />
                  </div>
                );
              })
            ) : (
              <></>
            )}
          </div>
        </Col>

        {/* If No Rooms */}
        {users?.length == 0 ? (
          <Col md={8} className={[classes.noRoomSelectedMainDiv].join(" ")}>
            <div className={[classes.noRoomSelectedDiv].join(" ")}>
              <div
                className={[
                  classes.dflex,
                  classes.contentcenter,
                  classes.mb16,
                ].join(" ")}
              >
                <ReactSVG
                  className={[classes.nochatIcon].join(" ")}
                  src={ChatIconRed}
                />
              </div>
              <h4
                className={[classes.textcenter, classes.mb16].join(" ")}
                style={{
                  ...Fonts.h4,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "26px",
                }}
              >
                You have no messages yet
              </h4>
              <p
                className={[classes.textcenter, classes.mb24].join(" ")}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
              >
                Haven’t found a couch you can talk yo about your lessons? Let’s
                fix that!
              </p>
              <Button
                primary={true}
                size={"Large"}
                label={"Start browsing"}
                customStyle={{ padding: "12px 42.5px", width: "max-content" }}
              />
            </div>
          </Col>
        ) : (
          <>
            {selectedroom ? (
              <Col md={8} className={[classes.relative].join(" ")}>
                <div
                  className={[
                    classes.chatbox,
                    classes.dflex,
                    classes.contentbetween,
                  ].join(" ")}
                >
                  <div className={[classes.dflex].join(" ")}>
                    <img
                      src={selectedroom?.img}
                      alt="..."
                      className={[classes.chatboxImg].join(" ")}
                    />
                    <div className={[classes.pl16].join(" ")}>
                      <h6
                        style={{
                          ...Fonts.h7,
                          fontFamily: "inter-600",
                          color: Colors.neutralShadesOfNero,
                          lineHeight: "24px",
                        }}
                        className={[classes.mb4].join(" ")}
                      >
                        1-on-1 Tennis Lesson with {selectedroom?.name}
                      </h6>
                      <ul className={["p-0", classes.dflex].join(" ")}>
                        <li
                          className={[classes.dflex, classes.itemscenter].join(
                            " "
                          )}
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          <ReactSVG
                            src={CalendarIconGray}
                            className={[classes.chatboxSvgicon].join(" ")}
                          />{" "}
                          <span className={[classes.pl8].join(" ")}>
                            {selectedroom?.lastMessage?.date}
                          </span>
                        </li>
                        <li
                          className={[
                            classes.dflex,
                            classes.itemscenter,
                            classes.ml16,
                          ].join(" ")}
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          <ReactSVG
                            src={ClockIconGray}
                            className={[classes.chatboxSvgicon].join(" ")}
                          />{" "}
                          <span className={[classes.pl8].join(" ")}>
                            {selectedroom?.lastMessage?.time}
                          </span>
                        </li>
                        <li
                          className={[
                            classes.dflex,
                            classes.itemscenter,
                            classes.ml16,
                          ].join(" ")}
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          <ReactSVG
                            src={LocationIconGray}
                            className={[classes.chatboxSvgicon].join(" ")}
                          />{" "}
                          <span className={[classes.pl8].join(" ")}>
                            {selectedroom?.lastMessage?.location}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={[classes.dflex].join(" ")}>
                    {selectedroom?.event?.status === "Lessson request" && (
                      <>
                        <Button
                          primary={false}
                          customStyle={{ marginRight: "8px" }}
                          icon={CancelIconBlack}
                        />
                        <Button primary={true} size={"Medium"}>
                          Accept
                        </Button>
                      </>
                    )}
                    {selectedroom?.event?.status ===
                      "Upcoming lesson in 3 days" && (
                      <>
                        <Button
                          primary={false}
                          label={"Cancel lesson"}
                          customStyle={{ ...Fonts.b2, width: "100%" }}
                        />
                      </>
                    )}
                    {selectedroom?.event?.status === "Lesson completed" && (
                      <></>
                    )}
                  </div>
                </div>
                {/* Chatting Box */}
                <Row
                  className={[
                    "g-0",
                    classes.chattingBoxRow,
                    `${replyObject && classes?.replyChattingboxRow}`,
                  ].join(" ")}
                >
                  <Col
                    md={12}
                    className={[classes.selfEnd, classes.messageCol].join(" ")}
                  >
                    <div className={[classes.chattingbox].join(" ")}>
                      {selectedRoomAllMessages?.map((item, i) => {
                        return (
                          <div
                            style={{
                              marginBottom:
                                item?.user_id?.id ==
                                selectedRoomAllMessages[i + 1]?.user_id?.id
                                  ? "8px"
                                  : "24px",
                            }}
                          >
                            {item?.creadtedAt ==
                            selectedRoomAllMessages[i - 1]?.creadtedAt ? (
                              <></>
                            ) : item?.booking ? (
                              <ul
                                className={[
                                  "p-0",
                                  classes.mb24,
                                  classes.dflex,
                                  classes.contentcenter,
                                ].join(" ")}
                              >
                                <li
                                  style={{
                                    ...Fonts.p2,
                                    color: Colors.neutralShadesOfDimGray,
                                  }}
                                  className={[
                                    classes.textcenter,
                                    classes.dInherit,
                                  ].join(" ")}
                                >
                                  <ReactSVG
                                    src={CalendarIconGray}
                                    className={[classes.bookingSvgicon].join(
                                      " "
                                    )}
                                  />
                                  Booking {item?.booking}
                                </li>

                                <li
                                  style={{
                                    ...Fonts.p2,
                                    color: Colors.neutralShadesOfDimGray,
                                  }}
                                  className={[classes.textcenter].join(" ")}
                                >
                                  <span
                                    className={[classes.dots].join(" ")}
                                    style={{
                                      backgroundColor:
                                        Colors.neutralShadesOfPinkSwan,
                                    }}
                                  />
                                  {item?.creadtedAt}
                                </li>
                                <li
                                  style={{
                                    ...Fonts.p2,
                                    color: Colors.neutralShadesOfDimGray,
                                  }}
                                  className={[classes.textcenter].join(" ")}
                                >
                                  <span
                                    className={[classes.dots].join(" ")}
                                    style={{
                                      backgroundColor:
                                        Colors.neutralShadesOfPinkSwan,
                                    }}
                                  />
                                  {item?.creadtedAt}
                                </li>
                              </ul>
                            ) : (
                              <p
                                style={{
                                  ...Fonts.p2,
                                  color: Colors.neutralShadesOfDimGray,
                                }}
                                className={[
                                  classes.textcenter,
                                  classes.mb24,
                                ].join(" ")}
                              >
                                {item?.creadtedAt}
                              </p>
                            )}

                            <MessageBox
                              item={item}
                              isImage={
                                item?.user_id?.id ===
                                selectedRoomAllMessages[i + 1]?.user_id?.id
                                  ? false
                                  : true
                              }
                              showName={
                                item?.user_id?.id ==
                                selectedRoomAllMessages[i - 1]?.user_id?.id
                                  ? false
                                  : true
                              }
                              i={i}
                              onClick={() => setIsDrawerOpen(true)}
                              setReplyObject={setReplyObject}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <div
                      className={classes.scrollToBottomContainer}
                      ref={emptyScrollRef}
                    />
                  </Col>
                </Row>

                <div
                  style={{
                    borderTop:
                      replyObject &&
                      `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  }}
                  className={[classes.chatSendInput].join(" ")}
                >
                  {replyObject && (
                    <div className={[classes.replyMessageDiv]}>
                      <div>
                        <ReactSVG
                          src={CancelIconBlack}
                          onClick={() => setReplyObject(null)}
                        />
                      </div>
                      <p
                        className={[classes.replyMessage]}
                        style={{
                          color: Colors.neutralShadesOfNero,
                          ...Fonts.p1,
                          borderLeft: `2px solid ${Colors.mainBlue}`,
                        }}
                      >
                        {replyObject?.messageText}{" "}
                      </p>
                    </div>
                  )}

                  <InputWithButton
                    type="text"
                    state={sendmessage}
                    setter={(e) => {
                      setSendMessage(e);
                    }}
                    placeholder="Type a message"
                    btnIcon={chatSendIcon}
                    buttonStyle={{
                      backgroundColor: Colors.white,
                      padding: "0px",
                    }}
                    customStyle={{ width: "100%" }}
                    onClick={() => {
                      HandleSendMessage();
                    }}
                    onKeyDown={(e) => e.keyCode == 13 && HandleSendMessage()}
                  />
                </div>
              </Col>
            ) : (
              <></>
            )}
          </>
        )}
      </Row>
      {/* side drawer  */}
      <Drawer
        open={isDrawerOpen}
        direction="right"
        enableOverlay={false}
        size={544}
      >
        <StudentDetails
          studentDetails={selectedroom}
          toggleDrawer={() => {
            setIsDrawerOpen(false);
          }}
        />
      </Drawer>
    </Container>
  );
};

export default ChatScreen;
